define('webshopProductsCategoriesListFiltersView',[
  'module',
  'backbone',
  'underscore',
  'webshopProductsCategoriesListFiltersEditView',
  'webshopProductsFinderListFiltersView'
], function (
  Module,
  Backbone,
  _,
  EditView,
  FinderFiltersView
) {
  'use strict';

  /**
   * Same filters as the products finder, plus "products without category".
   */
  Module.exports = FinderFiltersView.extend({
    editViewClass: EditView,
    settingsKey: 'webshopProductsCategoriesListFilters',

    getDefaultAttributes: function () {
      return _.extend(FinderFiltersView.prototype.getDefaultAttributes.apply(this, arguments), {
        status: '1',
        noCategory: ''
      });
    },

    setCollection: function () {
      if (this.model.get('noCategory') === '1') {
        this.collection.add(new Backbone.Model({
          id: 'noCategory',
          libelle: _.i18n('webshop.products.categories.filters.noCategory', null, 'Without category'),
          value: _.i18n('common.yes')
        }));
      }

      FinderFiltersView.prototype.setCollection.apply(this, arguments);
    },

    needFetch: function (model) {
      if (this.model.get('noCategory') !== model.get('noCategory'))
        return true;

      return FinderFiltersView.prototype.needFetch.apply(this, arguments);
    }
  });
});

